/* eslint-disable */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMyVW } from '../../context/myVWContext';
import { useMyVWQueryParams } from '../hooks/useMyVWQueryParams';
import i18n from '../../localization/i18n';
import * as rk from '../../localization/resourceKeys';

const MyVWAccountCheck: React.FC = () => {
  const navigate = useNavigate();
  const { externalId } = useMyVW();
  const { buildSearch } = useMyVWQueryParams();

  // useEffect(() => {
  //   if (!externalId) navigate('/myVW', { replace: true });
  // }, []);

  return (
    <div className="container">
      <h1 className="u-text-fs-5 u-mt-large">{i18n.t(rk.TITLE_MYVW_ACCOUNT_CHECK)}</h1>
      <p className="u-mt">{i18n.t(rk.TEXT_MYVW_ACCOUNT_CHECK)}</p>
      <div className="u-mt-large">
        <button
          className="c-btn u-ph-xlarge"
          onClick={() => navigate('/myVW/login' + buildSearch())}
        >
          <span className="c-btn__text">{i18n.t(rk.BUTTON_MYVW_YES_HAVE_ACCOUNT)}</span>
        </button>
        <button
          className="c-btn c-btn--secondary u-ph-xlarge u-ml"
          onClick={() => navigate('/myVW/register' + buildSearch())}
        >
          <span className="c-btn__text">{i18n.t(rk.BUTTON_MYVW_NO_HAVE_ACCOUNT)}</span>
        </button>
      </div>
    </div>
  );
};

export default MyVWAccountCheck;
